var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
// BluePrint JS
import { DatePicker as BPDatePicker } from '@blueprintjs/datetime';
// constants
import { prefix } from '../../constants';
export const DatePicker = (_a) => {
    var props = __rest(_a, []);
    return (React.createElement(BPDatePicker, Object.assign({ className: classNames(`${prefix}-datepicker`) }, props)));
};
//# sourceMappingURL=DatePicker.js.map